import { gql } from "@apollo/client";

export const FETCH_EMAIL_USAGE = gql`
  query EmailUsage {
    emailUsage
  }
`;

export const FETCH_EMAIL_USAGE_PAGE = gql`
  query EmailUsagePage($input: EmailUsageInput!) {
    emailUsage(input: $input)
  }
`;
